export const OCR_LIMITS = Object.freeze({
  maxFiles: 10,
  maxFileBytes: 20 * 1024 * 1024,
  maxRequestBytes: 80 * 1024 * 1024,
  maxPdfPages: 25,
  pollIntervalMs: 1200,
  jobTtlMs: 15 * 60 * 1000
});

export const OCR_ENDPOINTS = Object.freeze({
  jobs: '/ocr/jobs',
  translate: '/ocr-translate'
});

export const OCR_ACCEPT = [
  'image/jpeg', 'image/png', 'image/webp', 'image/avif', 'image/heic',
  'image/heif', 'image/tiff', 'image/bmp', 'image/gif', 'image/svg+xml',
  'application/pdf'
].join(',');
